<template>
    <section id="search">
        <div class="holder" v-if="holder"></div>
        <div v-else>
            <PageIntro title="Busca" :notbarproduct="true"/>
            <div class="container">
                <h2 v-if="!products.length" class="search-center">Não foi encontrado nenhum produto com esse nome</h2>
                <h2 v-else class="search-title">Resultados</h2>
                <div class="products">
                    <router-link :to="{ name: 'produto', params: { id: product.friendly_url}}"
                                 class="product"
                                 :key="index + 'produto-search'"
                                 v-for="(product, index) in products">
                        <div class="product__cart"><img src="@/assets/icons/tend-cart.svg" alt=""></div>
                        <img v-if="product.images.length" class="product__img" :src="product.images[0].permalink"
                             alt="">
                        <div class="product__info">
                            <h3 class="product__name">{{product.name}}</h3>
                            <span class="product__id">Ref: {{product.ref}}</span>
                        </div>
                    </router-link>
                </div>
            </div>

            <div class="page">
                <div class="ball"
                     :class="{active: current === index}"
                     @click="fetchPage(index + 1)"
                     :key="index + 'paginationsearch'"
                     v-for="(page, index) in pages">{{index + 1}}
                </div>
            </div>

            <TendenciesCarousel :content="productCarousel"/>
        </div>
    </section>
</template>

<script>
    import PageIntro from "../components/Shared/PageIntro";
    import TendenciesCarousel from "../components/Shared/TendenciesCarousel";

    export default {
        name: "Search",
        props: ['search'],
        data() {
            return {
                holder: true,
                products: [],
                pages: null,
                current: 0,
                productCarousel: [],
            }
        },
        methods: {
            fetchCarousel() {
                axios.get('/productdestc')
                    .then(r => {
                        this.productCarousel = r.data.data;
                    })
            },
            fetchProducts() {
                axios.get(`/product?ativo=1`, {
                    params: {
                        busca: this.search
                    }
                })
                    .then(r => {
                        this.$router.push(`/search/${this.search}`).catch(() => {});
                        this.products = r.data.data;
                        this.holder = false;
                        window.scrollTo({
                            behavior: 'smooth',
                            top: 0,
                        })
                    })
            },
        },
        watch: {
            $route: {
                handler: function () {
                    this.fetchProducts();
                    this.fetchCarousel()
                },
                immediate: true
            },
        },
        mounted() {
            this.fetchCarousel();
            this.fetchProducts();
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
            document.title = 'Fibrillare - Busca';
        },
        components: {
            PageIntro,
            TendenciesCarousel
        },
    }
</script>

<style lang="scss" scoped>
    .search-title {
        font-size: 2.5rem;
        font-weight: 500;
        margin-top: 60px;
    }

    .search-center {
        font-size: 2.5rem;
        font-weight: 500;
        margin-top: 100px;
        text-align: center;
    }

    .products {
        display: flex;
        flex-wrap: wrap;
        margin-left: -15px;
        margin-right: -15px;
        margin-top: 60px;
    }

    .product__info {
        position: relative;
        flex-grow: 1;
        align-self: flex-end;
        width: 100%;
    }

    .product {
        margin: 0 10px;
        flex-shrink: 0;
        width: 270px;
        height: auto;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 20px;
        border: 1px solid transparent;
        position: relative;

        &:hover {
            border: 1px solid rgba(0, 0, 0, .1);
        }

        &__cart {
            transition: all .2s;
            opacity: 0;
            transform: translate3d(20px, 0, 0);
            position: absolute;
            right: 20px;
            top: 20px;
            width: 20px;
            height: 20px;
            cursor: pointer;
        }

        &__img {
            object-fit: contain;
            width: 228px;
            height: 184px;
            margin-top: 20px;
            margin-bottom: 10px;
        }

        &__name {
            margin-bottom: 10px;
            font-family: "Open Sans";
            font-size: 1rem;
            font-weight: 600;
            color: #2b2b2b;
        }

        &__id {
            font-family: "Encode Sans";
            font-size: 0.75rem;
            color: #4d4d4d;
        }
    }

    .product:hover .product__cart {
        opacity: 1;
        transform: translate3d(0, 0, 0)
    }

    @media only screen and (max-width: 1200px) {
        .products {
            justify-content: center;
        }
    }

    @media only screen and (max-width: 1024px) {
        .product__cart {
            transform: translate3d(0, 0, 0);
            opacity: 1;
        }
    }
</style>